export const CSS_PRELUDE = `\
@layer {
  * {
    font-family: Inter, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }
  button {
    font-family: inherit;
  }
}`;
